import axios from 'axios';

import authHeader from './authHeader';
import { Config } from '@/config';

class AuthService {
  async login() {
    try {
      const response = await axios.post(`${Config.HOST.URL}${Config.API_ROUTES.LOGIN}`, {
        app_id: Config.PARKKI_APP.ID,
        api_key: Config.PARKKI_APP.KEY,
      });
      if (response.data !== undefined && response.data.app !== undefined && response.data.access_token !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  async requestAccessToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken !== null) {
      try {
        const instance = axios.create(); // New instance of axios. Exclude interceptor auth failed
        const response = await instance.get(`${Config.HOST.URL}${Config.API_ROUTES.REQUEST_TOKENS}`, { headers: { 'X-Refresh-Token': `${JSON.parse(refreshToken).token}` } });
        if (response.data !== undefined) {
          return response.data;
        }
      } catch (error) {
        return this.login();
      }
    } else {
      return this.login();
    }
  }

  async getSettings() {
    try {
      const response = await axios.get(`${Config.HOST.URL}${Config.API_ROUTES.APP_SETTINGS}?version=${Config.PARKKI_APP.VERSION}`, { headers: authHeader() });
      if (response.data !== undefined) {
        return response.data;
      }
    } catch (error) {
      throw error.message;
    }
  }

  logout() {
    localStorage.clear();
  }
}

export default new AuthService();
